import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Pricing({ packages, hostingName, packageTagline }) {
    const centerIndex = Math.floor(packages.length / 2);
    const [activeHoverIndex, setActiveHoverIndex] = useState(centerIndex);

    const handleMouseEnter = (index) => {
        setActiveHoverIndex(index);
    };

    return (
        <div className="sbbs-pricing-area mg-top-100">
            <div className="container">
                <div className="row justify-content-center">    
                    <div className="col-xl-7">
                        <div className="section-title text-center pb-5">
                            <h2 className="title"> {hostingName} <span>Packages</span></h2>
                            <p> {packageTagline} </p>
                        </div>
                    </div>
                </div>
                <div className="row no-gutters justify-content-center">
                    {packages.map((packageItem, index) => (
                        <div key={index} className="col-xl-3 col-lg-4 col-sm-6">
                            <div className={`single-pricing text-center ${activeHoverIndex === index ? 'single-pricing-active' : ''}`} onMouseEnter={() => handleMouseEnter(index)}>
                                <h6 className="title">{packageItem.name}</h6>
                                <div className="thumb">
                                    <img src={packageItem.icon} alt="pricing" />
                                </div>
                                <h3 className="price">{packageItem.price}</h3>
                                <ul>
                                    {packageItem.features.map((feature, featureIndex) => (
                                        <li key={featureIndex}>{feature}</li>
                                    ))}
                                </ul>
                                <Link className="btn btn-white btn-rounded" href="#">Get Started</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Pricing;
